import { render } from "./UnternehmenspraesentationList.vue?vue&type=template&id=88adf2a2"
import script from "./UnternehmenspraesentationList.vue?vue&type=script&lang=js"
export * from "./UnternehmenspraesentationList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__